import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

interface SkillAssessmentPillProps {
  size?: PillSize;
  variant?: PillVariant;
}

export function SkillAssessmentPill(props: SkillAssessmentPillProps) {
  const { size = "small", variant = "outlined" } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label="Demo Shift"
      iconType="locked-filled"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      outlineColor={(theme) => theme.palette.intent?.neutral.border}
      color={(theme) => theme.palette.intent?.neutral.text}
      iconColor={(theme) => theme.palette.intent?.neutral.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
